'use client';

import Button from '@components/buttons/Button';
import React from 'react';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';
import { storefrontUrl } from '@utils/storefront-url';

const Newsletter = () => {
  return (
    <section className="home-section reveal" aria-labelledby="pros-title">
      <div className="home-wrap">
        <div className="pros">
          <div className="pros__copy">
            <p className="pros__eyebrow">Para profesionales</p>
            <h2 id="pros-title" className="pros__title font-display">
              ¿Tenés un negocio de belleza? Sumalo a Ágora.
            </h2>
            <p className="pros__text">
              Creá tu perfil gratis, mostrá tus servicios con precios y aparecé en el mapa de tu zona.
            </p>
          </div>

          <div className="pros__actions">
            <Button
              href="/signup"
              type="primary"
              className="!rounded-full !px-7 !h-12 !text-sm !bg-white !border-white !text-[#0b1324] hover:!bg-primary-50"
              onClick={() => trackEvent(EVENTS.HOME_CTA_CLICKED, { cta: 'comenzar_gratis', section: 'newsletter' })}
            >
              Crear mi perfil gratis
            </Button>
            <Button
              href={storefrontUrl('/funcionalidades', { campaign: 'pro_cta', content: 'conocer_mas' })}
              type="outlined"
              external
              className="!rounded-full !px-7 !h-12 !text-sm !bg-transparent !border-white/20 !text-white hover:!bg-white/10 hover:!border-white/30 hover:!translate-y-0"
              onClick={() => trackEvent(EVENTS.HOME_CTA_CLICKED, { cta: 'conocer_mas', section: 'newsletter' })}
            >
              Ver funcionalidades
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
